import { Operation } from 'shell/view-models/operation';
import { paginationListToQueryString } from 'system/utils/list-object-to-query-string';
import { OperationObject } from 'system/utils/operation-object-to-query-string';
import { ResearchRegisterVM } from 'practice/view-models/research-register';
import { Order } from 'shell/view-models/order';

export const transformDataset = (values: ResearchRegisterVM): string => {
  const transformedFilters: OperationObject = {
    tipoRegistro: { value: values.filter?.typeRegister || '', operation: Operation.LIKE },
    descrizioneRegistro: {
      value: values.filter?.description || '',
      operation: Operation.LIKE,
    },
  };

  const ordersToTransform = values.filter?.orders || {};
  const ordersMapped: Order = {
    tipoRegistro: ordersToTransform?.type,
    descrizioneRegistro: ordersToTransform?.description,
  };

  return `${paginationListToQueryString({
    filters: transformedFilters,
    orders: ordersMapped,
  })}`;
};
